
import { Helmet } from "react-helmet";
import NewHeader from "../../UiComponent/NewHeader";
import AuthAction from "./AuthAction";
import { defaultLabelColors } from "../../utils/constants";
import MobileResponsive from "../LandingPage/MobileResponsive";

function LoginPage(props: any) {
  return (
    <>
      <Helmet>
        <title>Connexion à Frank | Accédez à Votre Compte</title>
        <link rel="canonical" href="https://www.frank.fr/login" />
          <link
          rel="icon"
          type="image/png"
          href="../../../public/frank_favicon.png"
        />
        <meta
          name="description"
          content="Connectez-vous à votre compte Frank pour gérer vos envois, consulter vos annonces et interagir avec la communauté. Rejoignez-nous et profitez de nos services de livraison collaborative."
        />
      </Helmet>
      <div
        style={{ background: defaultLabelColors?.main_background_new }}
        className="web-screen"
      >
        <div
          style={{
            zIndex: 1111,
            background: defaultLabelColors?.main_background_new,
            justifyItems: "center",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              maxWidth: 1408,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection:'column'
            }}
          >
            <NewHeader />
            {" "}
            <AuthAction />
          </div>
          
        </div>
      </div>

      <div className="mobile-screen">
        <MobileResponsive />
      </div>

      {/* <div
            className="main-container"
            style={{ background: "#f9c7b8", marginTop: "50px" }}
          >
            <CustomFooter />
          </div> */}
    </>
  );
}

export default LoginPage;
